import React from "react";
import Typography from "@mui/material/Typography";
import { formatEmpty, formatCurrency } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function CurrencyCell(cell) {
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  return (
    <span style={{ display: "flex", justifyContent: "end", alignItems: "center" }}>
      <Typography
        variant="body1"
        sx={{
          color: cell.value < 0 ? "error.main" : active ? "white_opacity.100" : "black_solid.80",
        }}
      >
        {formatEmpty(formatCurrency(cell.value, 2))}
      </Typography>
    </span>
  );
}
